import { render, staticRenderFns } from "./ToDeliverParcels.vue?vue&type=template&id=63ca8ccf&"
import script from "./ToDeliverParcels.vue?vue&type=script&lang=js&"
export * from "./ToDeliverParcels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports